var now = new Date(); // 当前日期
var nowDayOfWeek = now.getDay(); // 今天本周的第几天
var nowDay = now.getDate(); // 当前日
var nowMonth = now.getMonth(); // 当前月
var nowYear = now.getYear(); // 当前年
nowYear += (nowYear < 2000) ? 1900 : 0;
  
export default {
    /**
     * 获得当前日期
     *
     * @returns
     */
    getNowDay() {
        return this.formatDate(new Date());
    },
    /**
     * 获得当前日期年份
     *
     * @returns
     */
     getNowYear() {
      return nowYear;
    },
    /**
     * 获得本周的开始时间
     *
     * @returns
     */
    getStartDayOfWeek() {
        var day = nowDayOfWeek || 7;
        return this.formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 1 - day));
    },
    /**
     * 获得本周的结束时间
     *
     * @returns
     */
    getEndDayOfWeek() {
        var day = nowDayOfWeek || 7;
        return this.formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 7 - day));
    },
    /**
     * 获得本月的开始时间
     *
     * @returns
     */
    getStartDayOfMonth() {
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        return this.formatDate(monthStartDate);
    },
    /**
     * 获得本月的结束时间
     *
     * @returns
     */
    getEndDayOfMonth() {
        var monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays());
        return this.formatDate(monthEndDate);
    },
    /**
     * 获得本月天数
     *
     * @returns
     */
    getMonthDays() {
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        var monthEndDate = new Date(nowYear, nowMonth + 1, 1);
        var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
        return days;
    },
    /**
   *
   * 获取某个日期的几个月前的日期
   * date 输入日期(new Date())
   * monthNum 月数
   */
  preMonthDay(date, monthNum) {
    if (!date) return "";
    var currYear = new Date(date).getFullYear(); //获取当前日期的年份
    var currMonth = new Date(date).getMonth(); //获取当前日期的月份
    var currDay = new Date(date).getDate(); //获取当前日期的日
    var year2 = currYear;
    var month2 = parseInt(currMonth) - monthNum;
    if (month2 <= 0) {
      var absM = Math.abs(month2);
      year2 =
        parseInt(year2) - Math.ceil(absM / 12 == 0 ? 1 : parseInt(absM) / 12);
      month2 = 12 - (absM % 12);
    }
    var day2 = currDay;
    var days2 = new Date(year2, month2, 0).getDate(); //获取之前日期中月的天数
    if (day2 > days2) {
      day2 = days2;
    }
    if (month2 < 10) {
      month2 = "0" + month2;
    }
    return this.formatDate(new Date(year2, month2, day2));
  },
  /**
   * @param 日期格式化
   * @returns {String}
   */
  formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();

      if (mymonth < 10) {
          mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
          myweekday = "0" + myweekday;
      }
      return (myyear + "-" + mymonth + "-" + myweekday);
  },
  /**
   * @param 日期格式化
   * @returns {String}
  */
  minTime(val) {
    let minTime = "";
    let h = Math.floor(val / 60);
    val -= h * 60;
    if (val == 0) {
      minTime = h ? h + "小时" : "";
    } else {
      if (val < 10) {
        val = "0" + val;
      }
      minTime = (h ? h + "小时" : "") + (val ? val + "分钟" : "");
    }
    return minTime || '-';
  }
};
